<template>
    <div id="appointment-dialog">

        <datetime :show-input="false"
                  ref="datetime"
                  locale="es"
                  v-model="time"
                  type="time"/>

        <div class="modal fade"
             id="contact-modal"
             tabindex="-1"
             role="dialog"
             aria-labelledby="contactModal"
             aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header" style="margin-top: 20px;">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form v-on:submit.prevent="sendMessage"
                              novalidate
                              method="POST"
                              accept-charset="UTF-8"
                              id="appointment-form"
                              enctype="multipart/form-data"
                              class="container-fluid text-left text-black font-weight-normal">
                            <header class="d-flex align-items-center mb-4">
                                <i class="bg-family mb-2 mr-2"></i>
                                <h2 class="mb-4">{{ __('site.Make-your-inquirie') }}</h2></header>
                            <div class="row">
                                <div class="col-lg-6 col-xs-12 flex-first flex-sm-unordered">
                                    <fieldset>
                                        <div class="mb-4">
                                            <input :placeholder="__('forms.Your-name')"
                                                   required="required"
                                                   name="first_name"
                                                   v-model="first_name"
                                                   type="text"
                                                   class="form-control shadow border-0">
                                            <small v-if="errors.first_name"
                                                   v-text="errors.first_name[0]"
                                                   class="text-danger">
                                            </small>
                                        </div>

                                        <div class="mb-4">
                                            <input pattern="[0-9]{9}"
                                                   :placeholder="__('forms.Your-phone-number')"
                                                   min="9"
                                                   required="required"
                                                   name="mobile"
                                                   v-model="mobile"
                                                   type="tel"
                                                   class="form-control shadow border-0">

                                            <small v-if="errors.mobile"
                                                   v-text="errors.mobile[0]"
                                                   class="text-danger">
                                            </small>
                                        </div>

                                        <div class="mb-4">
                                            <input :placeholder="__('forms.Your-dni')"
                                                   required="required"
                                                   name="dni"
                                                   v-model="dni"
                                                   type="text"
                                                   class="form-control shadow border-0">
                                            <small v-if="errors.dni"
                                                   v-text="errors.dni[0]"
                                                   class="text-danger">
                                            </small>
                                        </div>
                                    </fieldset>
                                </div>

                                <div class="col-lg-6 col-xs-12">
                                    <div class="mb-4">
                                        <input :placeholder="__('forms.Your-surname')"
                                               required="required"
                                               name="last_name"
                                               v-model="last_name"
                                               type="text"
                                               class="form-control shadow border-0">
                                        <small v-if="errors.last_name"
                                               v-text="errors.last_name[0]"
                                               class="text-danger">
                                        </small>
                                    </div>

                                    <div class="mb-4">
                                        <input :placeholder="__('forms.Your-email')"
                                               required="required"
                                               name="email"
                                               v-model="email"
                                               type="email"
                                               class="form-control shadow border-0">

                                        <small
                                          v-if="errors.email"
                                          v-text="errors.email[0]"
                                          class="text-danger">
                                        </small>
                                    </div>

                                    <div class="mb-4">
                                        <label>
                                            <select class="form-control shadow border-0"
                                                    name="channel"
                                                    v-model="channel"
                                                    id="channel">
                                                <option value="default" disabled selected>¿Cómo nos has conocido?</option>
                                                <option value="word of mouth">A través de un amigo/a</option>
                                                <option value="google">Buscador de Internet</option>
                                                <option value="social networks">Redes Sociales</option>
                                                <option value="bank">Banco</option>
                                                <option value="directories">Páginas Amarillas / Directorios</option>
                                                <option value="other">Otros</option>
                                            </select>
                                            <small v-if="errors.channel"
                                                   v-text="errors.channel[0]"
                                                   class="text-danger">
                                            </small>
                                        </label>
                                    </div>
                                    <!--<fieldset>
                                        <div class="col-12 col-lg-12">
                                            <div class="brand-title small">¿Quieres solicitar día y fecha?</div>
                                            <div class="text-center"><small>(Pendiente de confirmar)</small></div>
                                            <vue-event-calendar :events="[]" @day-changed="dayChanged"/>
                                            <input type="hidden" name="date" v-model="date">
                                            <small
                                                    v-if="errors.date"
                                                    v-text="errors.date[0]"
                                                    class="text-danger">
                                            </small>
                                        </div>
                                    </fieldset>
                                    <div class="col-12 col-lg-12 form-group text-center" style="min-width: 15rem;"
                                         v-show="date">
                                        <button ref="input"
                                                type="button"
                                                class="px-4 mt-2 btn btn-sm btn-outline-primary text-uppercase cursor-pointer"
                                                @click="$refs.datetime.open()"
                                                @focus="$refs.datetime.open()">
                                            <i class="text-lg mr-2 icon-clock"></i>
                                            {{time.replace(/([\d]+:[\d]{2})(:[\d]{2})(.*)/, '$1')}}
                                        </button>
                                        <small v-if="errors.time"
                                               v-text="errors.time[0]"
                                               class="text-danger">
                                        </small>
                                    </div !-->
                                </div>
                                <div class="col-lg-12 col-xs-12 flex-first flex-sm-unordered" style="min-width: 15rem;">
                                    <fieldset class="form-group">
                                <textarea :placeholder="__('forms.Your-inquiry')"
                                          required="required"
                                          name="reason"
                                          v-model="reason"
                                          cols="50"
                                          rows="10"
                                          class="form-control shadow border-0"></textarea>
                                        <small v-if="errors.reason"
                                               v-text="errors.reason[0]"
                                               class="text-danger">
                                        </small>
                                    </fieldset>
                                </div>

                                <div class="col-lg-12 col-xs-12 form-group" style="min-width: 15rem;">
                                    <label class="form-check-label">
                                        <input required="required"
                                               name="terms"
                                               v-model="terms"
                                               type="checkbox"
                                               class="form-check-input">
                                        <a href="/legal" target="_blank" class="text-xs">
                                            {{ __('forms.Accept-terms-and-conditions') }}
                                        </a>
                                        <br/>
                                        <small v-if="errors.terms"
                                               v-text="errors.terms[0]"
                                               class="text-danger">
                                        </small>
                                    </label>
                                </div>
                            </div>
                            <fieldset class="row flex-nowrap">
                                <div class="col-12 col-lg-12 text-right form-group text-center">
                                    <input type="submit"
                                           :disabled="isSubmit"
                                           :value="__('site.Send')"
                                           class="btn btn-outline-secondary cursor-pointer"
                                           required>
                                </div>
                            </fieldset>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <modal-alert @confirm="successSendForm = false" v-if="successSendForm">
            <span slot="header">{{ __('alerts.appointment.header') }}</span>
            {{ __('alerts.appointment.message') }}
        </modal-alert>

    </div>
</template>

<script>
  export default {
    data: function () {
      return {
        isSubmit: false,
        openModalBox: false,
        successSendForm: false,
        channel: 'default',
        inputFiles: [],
        errors: [],
        date: null,
        time: '09:30',
        attachedJSON: {},
        first_name: null,
        last_name: null,
        dni: null,
        email: null,
        mobile: null,
        reason: null,
        terms: null
      }
    },

    mounted: function () {
      bus.$on('openContactModalBox', () => {
        $('#contact-modal').modal('show')
      })

      $('#app').on('click', '[data-form-contact]', event => {
        event.preventDefault()

        $('#contact-modal').modal('show')
      })

      bus.$on('attachJsonToContactDialog', (results) => {
        this.attachedJSON = results
      })
    },

    computed: {
      inputCurrentFiles: {
        get: function () {
          return this.inputFiles
        },
        set: function (files) {
          this.inputFiles = files
        }
      }
    },

    methods: {
      sendMessage: function (form) {
        this.isSubmit = true
        this.errors = {}

        let time = this.time.split(':')

        let formData = {
          first_name: this.first_name,
          last_name: this.last_name,
          dni: this.dni,
          email: this.email,
          mobile: this.mobile,
          date: this.date,
          reason: this.reason,
          channel: this.channel,
          terms: this.terms,
          time: `${time[0]}:${time[1]}`
        }

        if (Object.keys(this.attachedJSON).length) {
          formData.origin_comment = this.attachedJSON
        }

        this.$http.post('/contact/appointment', formData).then(
          response => {
            // ga('send', 'event', 'appointment', 'enviar', null, 1)

            Object.assign(this.$data, this.$options.data.call(this))
            this.date = null
            $('#contact-modal').modal('hide')

            this.successSendForm = true
            this.isSubmit = false
          },
          response => {
            // Error
            console.log(response)
            this.isSubmit = false
            this.errors = Object.assign({}, this.errors, response.response && response.response.data)
            // ga('send', 'event', 'appointment', 'enviar', null, 0)
          }
        )
      },
      dayChanged: function (value) {
        this.date = value.date
        this.$refs.datetime.open()
      }
    }
  }
</script>
<style lang="scss">

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/ContactDialog.vue